import { apiClient } from '../api/apiClient';

export interface BooksellerAuthTestResult {
  success: boolean;
  errorMessage?: string;
  details?: string;
}

export interface EntitlementApiTestResult {
  success: boolean;
  errorMessage?: string;
  responseTimeMs: number;
  entitlementsCount?: number;
  sampleIsbn?: string[];
  statusCode?: number;
  rawResponse?: string;
}

export interface BooksellerDto {
  id: string;
  name: string;
  description?: string;
  logoUrl?: string;
}

/**
 * Service for testing bookseller authentication and entitlement APIs
 */
export const booksellerTestService = {
  /**
   * Get all booksellers (for dropdown)
   */
  async getAllBooksellers(): Promise<BooksellerDto[]> {
    const response = await apiClient.get('/api/app/booksellers');
    return response.data.items || response.data;
  },

  /**
   * Test OAuth/OIDC authentication configuration
   */
  async testAuthentication(booksellerId: string): Promise<BooksellerAuthTestResult> {
    const response = await apiClient.post(
      `/api/app/booksellers/${booksellerId}/test-auth`
    );
    return response.data;
  },

  /**
   * Test entitlement API with test email
   */
  async testEntitlementApi(
    booksellerId: string,
    testEmail: string
  ): Promise<EntitlementApiTestResult> {
    const response = await apiClient.post(
      `/api/app/booksellers/${booksellerId}/test-entitlement-api`,
      null,
      {
        params: { testEmail }
      }
    );
    return response.data;
  }
};
